export const aranceles = [
  {
    categoria: "Operatoria General",
    items: [
      { nombre: "Consulta y examen clínico completo", precio: 1740 },
      { nombre: "Radiografía periapical", precio: 2628 },
      { nombre: "Radiografía bite-wing", precio: 2628 },
      { nombre: "Profilaxis dental", precio: 1967 },
      { nombre: "Aplicación flúor tópico", precio: 1097 },
      { nombre: "Obturación 1 superficie (amalgama)", precio: 14480 },
      { nombre: "Obturación 2 superficies (amalgama)", precio: 18720 },
      { nombre: "Obturación 1 superficie (resina)", precio: 37170 },
      { nombre: "Obturación 2 superficies (resina)", precio: 44760 },
      { nombre: "Sellante de fosas y fisuras", precio: 3220 },
    ],
  },
  {
    categoria: "Cirugías",
    items: [
      { nombre: "Exodoncia simple", precio: 17960 },
      { nombre: "Exodoncia con odontosección", precio: 44000 },
      { nombre: "Exodoncia 3er molar erupto", precio: 44000 },
      { nombre: "Exodoncia 3er molar incluido", precio: 118000 },
      { nombre: "Alveoloplastía", precio: 32000 },
      { nombre: "Biopsia de tejidos blandos", precio: 47000 },
      { nombre: "Frenectomía", precio: 47000 },
    ],
  },
  {
    categoria: "Endodoncia",
    items: [
      { nombre: "Pulpotomía (diente temporal)", precio: 14960 },
      { nombre: "Endodoncia unirradicular", precio: 50000 },
      { nombre: "Endodoncia birradicular", precio: 70000 },
      { nombre: "Endodoncia trirradicular", precio: 100000 },
      { nombre: "Retratamiento endodóntico", precio: 100000 },
    ],
  },
  {
    categoria: "Periodoncia",
    items: [
      { nombre: "Raspado y alisado radicular (por cuadrante)", precio: 23470 },
      { nombre: "Curetaje gingival (por cuadrante)", precio: 16380 },
      { nombre: "Gingivectomía", precio: 56750 },
    ],
  },
  {
    categoria: "Prótesis",
    items: [
      { nombre: "Prótesis total superior", precio: 143170 },
      { nombre: "Prótesis total inferior", precio: 143170 },
      { nombre: "Prótesis parcial removible (acrílico)", precio: 100000 },
      { nombre: "Corona metal-porcelana", precio: 153100 },
      { nombre: "Corona full porcelana", precio: 180000 },
    ],
  },
  {
    categoria: "Implantología",
    items: [
      { nombre: "Implante oseointegrado (por unidad)", precio: 500000 },
      { nombre: "Corona sobre implante", precio: 180000 },
    ],
  },
  {
    categoria: "Ortodoncia",
    items: [
      { nombre: "Ortodoncia fija completa", precio: 800000 },
      { nombre: "Ortodoncia interceptiva", precio: 400000 },
      { nombre: "Retenedores", precio: 80000 },
    ],
  },
  {
    categoria: "Odontopediatría",
    items: [
      { nombre: "Obturación temporal (ionómero)", precio: 8000 },
      { nombre: "Corona de acero", precio: 25000 },
      { nombre: "Mantenedor de espacio fijo", precio: 45000 },
    ],
  },
];
